import { IObject } from "@quest/adapter-interface";
import {
  Bitmap,
  ILabelBitmap,
  ISpineData,
  SpineBase,
  detectDeviceEnvironmentConstants,
  dispatcher,
  ingenuity,
  // ITween,
  AnimationBase,
  Label,
  Meter,
  IEvent,
} from "@quest/base-core";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { gameConstants } from "../../Constants/gameConstants";
import { BaseViewBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
export class HoldAndReSpinView extends BaseViewBehavior {
  private charEffects: SpineBase;
  private reelBGGlow: SpineBase;
  constructor(json: any) {
    super(json);
    this.subscribeEvents();
  }

  //private bonusWinMeterPortrait: MeterBitmap;

  /** overrided to initialize winmeter bonus portrait*/
  protected initializeComponents(): void {
    super.initializeComponents();
    this.reelBGGlow = this.getSpineById("bonusgame_reel_bg_glow");
    this.charEffects = this.getSpineById("characterEffects");
    // if (!ingenuity.deviceEnv.isDesktop) {
    //   this.bonusWinMeterPortrait = this.getMeterById("winValue") as MeterBitmap;
    // }
  }

  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.HIDE_BONUS_REEL, this.hideView, this);
    dispatcher.on(eventDispatchers.SHOW_BONUS_REEL, this.showView, this);
    dispatcher.on(eventDispatchers.PLAY_HIT_ANIM_RESPIN, this.playSideCharEffects, this);
    dispatcher.on(eventDispatchers.PLAY_MULTIPLIER_LOOP_ANIM, this.playMultiplierLoopGlowAnim, this);
    dispatcher.on(eventDispatchers.STOP_MULTIPLIER_LOOP_ANIM, this.stopMultiplierLoopGlowAnim, this);
  }
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.HIDE_BONUS_REEL, this.hideView, this);
    dispatcher.off(eventDispatchers.SHOW_BONUS_REEL, this.showView, this);
    dispatcher.off(eventDispatchers.PLAY_HIT_ANIM_RESPIN, this.playSideCharEffects, this);
    dispatcher.off(eventDispatchers.PLAY_MULTIPLIER_LOOP_ANIM, this.playMultiplierLoopGlowAnim, this);
    dispatcher.off(eventDispatchers.STOP_MULTIPLIER_LOOP_ANIM, this.stopMultiplierLoopGlowAnim, this);
  }

  private playSideCharEffects(data: IEvent): void {
    let color;
    if (data.data.charId == gameConstants.SKULL_MULTIPLIER) {
      color = "Red";
    } else if (data.data.charId == gameConstants.SKULL_BIG_PRIZE) {
      color = "Blue";
    } else {
      color = "Green";
    }
    let char = this.getSpineById("type_" + data.data.charId);
    this.charEffects.x = char.x;
    this.charEffects.y = char.y;
    this.charEffects.visible = true;
    this.charEffects.playAnim(color + "_element_glow_effect");
  }

  private getMutliplierPosition():void{
    let parent = this.getContainerByID('baseGameLeftBonusPanelContainer');
    let child  = parent.getChildByName('multiplierValue');
    if(child){
      child.y = this.getSpineById(`type_151`).y + 52;
    }
  }

  private playMultiplierLoopGlowAnim(): void {
    let char = this.getSpineById("type_151");
    this.charEffects.visible = true;
    char.transform && (this.charEffects.x = char.x);
    char.transform && (this.charEffects.y = char.y);
    this.charEffects.playAnim("Multiplier_level_up_glow_loop", true);
  }

  private stopMultiplierLoopGlowAnim(): void {
    let char = this.getSpineById("type_151");
    this.charEffects.visible = true;
    this.charEffects.x = char.x;
    this.charEffects.y = char.y;
    this.charEffects.playAnim("Multiplier_level_up_glow_end");
    this.charEffects.onComplete.addOnce(() => {
      this.charEffects.visible = false;
    });
  }



  /**
   * Method to hide the class view
   */
  private hideView(): void {
    this.visible = false;
    //!ingenuity.deviceEnv.isDesktop && (this.getContainerByID("winMeterContainer").visible = false);
  }
  /**
   * Method to hide the class view
   */
  private showView(): void {
    this.visible = true;
    this.playBgGlow();
  }

  private playBgGlow() {
    this.reelBGGlow.visible = true;
    this.reelBGGlow.playAnim("bonusgame_reel_glow", true);
  }
  /**Set reel view for prize spin view */
  public setReelView(reelView: any, pos?: number, parentId?: string): void {
    this.addChildAt(this.getContainerByID("bonusReelsContainer"), 0);
    this.addChildAt(reelView, 1);
  }
  /**
   * to clone spine animation
   * function used here because createSpine is protected and not able to use outside view
   */
  public getSpineJsonAndClone(name: string): SpineBase {
    let bonusIdleSpineObj: ISpineData = ingenuity.assetsData.getJSONById("main_data").holdAndReSpin[name];
    bonusIdleSpineObj.type = "spine";
    let bonusSpineAnimClone: SpineBase = this.createSpine(bonusIdleSpineObj);
    bonusSpineAnimClone.visible = true;
    return bonusSpineAnimClone;
  }

  // Create animation clone
  public getAnimationJsonAndClone(name: string): AnimationBase {
    let bonusCoinGlowObj: any = ingenuity.assetsData.getJSONById("main_data").holdAndReSpin[name];
    bonusCoinGlowObj.type = "animation";
    let bonusCoinAnimClone: AnimationBase = this.createAnimation(bonusCoinGlowObj);
    bonusCoinAnimClone.visible = true;
    return bonusCoinAnimClone;
  }

  /**
   * to clone blank reel BG image
   */
  public getImageJsonAndClone(): Bitmap {
    let blankImgObj: any = ingenuity.assetsData.getJSONById("main_data").holdAndReSpin["blankReelBg"];
    blankImgObj.type = "image";
    let blankImageClone: Bitmap = this.createImage(blankImgObj);
    blankImageClone.visible = false;
    return blankImageClone;
  }
  /**
   * to clone Meter Bitmap Text of initial symbols
   */
  public getMeterBitmapJsonAndClone(color: string): Meter {
    let bitmapMeterObject: ILabelBitmap = ingenuity.assetsData.getJSONById("main_data").holdAndReSpin[`${color}_AmtMeterText`];
    bitmapMeterObject.type = "meter";
    let bitmapMeterTextClone: Meter = this.createMeter(bitmapMeterObject) as Meter;
    //bitmapMeterTextClone.visible = true;
    bitmapMeterTextClone.name = color;
    return bitmapMeterTextClone;
  }

  /**
   * To clone label for trail multiplier values
   */
  public getLabelJsonAndClone(multValue: string, startX: number, startY: number, endX: number, endY: number): Label {
    let labelObject: any = ingenuity.assetsData.getJSONById("main_data").holdAndReSpin["betPerLineTextLabel"];
    labelObject.x = startX;
    labelObject.y = startY;
    labelObject.type = "label";
    labelObject.text = multValue + "x";
    let labelTextClone: Label = this.createLabel(labelObject) as Label;
    labelTextClone.visible = true;
    labelTextClone.name = multValue + endX + endY + "Label";
    return labelTextClone;
  }

  protected resize(e?: IObject): void {
    this.pivot.set(ingenuity.configData.width / 2, ingenuity.configData.height / 2);
    this.x = innerWidth / 2;
    this.y = innerHeight / 2;
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.pivot.set(
        ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER,
        ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER
      );
      this.scale.set(ingenuity.deviceEnv.getPortraitMaxReelScale());
      this.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER;
      //In case of IPAD the value is different
      if (ingenuity.deviceEnv.device === gameConstants.IPAD) {
        this.y =
          innerHeight * SlotConstantsBehavior.HALF_CONVERTER +
          SlotConstantsBehavior.ADD_IN_Y +
          gameConstants.BONUS_ALLIGN_WITH_BASE_GAME_ON_PORTRAIT_IPAD;
      } else {
        this.y =
          innerHeight * SlotConstantsBehavior.HALF_CONVERTER +
          SlotConstantsBehavior.ADD_IN_Y +
          gameConstants.BONUS_ALLIGN_WITH_BASE_GAME_ON_PORTRAIT;
      }
    } else {
      this.pivot.set(
        ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER,
        ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER
      );
      this.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER;

      if (ingenuity.deviceEnv.isDesktop) {
        this.y = innerHeight * SlotConstantsBehavior.HALF_CONVERTER + SlotConstantsBehavior.VIEW_SLIDE_DESKTOP;
        this.scale.set(e.data.scale * gameConstants.ADD_SCALE_REEL_DESKTOP);
      } else {
        this.y = innerHeight * SlotConstantsBehavior.HALF_CONVERTER + SlotConstantsBehavior.VIEW_SLIDE_MOBILE;
        this.scale.set(e.data.scale * gameConstants.ADD_SCALE_REEL);
      }
      this.scale.set(ingenuity.deviceEnv.getLandcapeMaxReelScale());
    }
    if (!ingenuity.deviceEnv.isDesktop) {
      if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
        this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
        this.updateOrientation();
      }
    }
    this.getMutliplierPosition();
  }

  public destroy(): void {
    super.destroy();
    this.unSubscribeEvents();
  }
}
